import { useContext } from 'react';
import { observer } from 'mobx-react-lite';

// import Radio from '@mui/joy/Radio';
// import RadioGroup from '@mui/joy/RadioGroup';
import ToggleButtonGroup from '@mui/joy/ToggleButtonGroup';
import Button from '@mui/joy/Button';
import Chip from '@mui/joy/Chip';

import MenuItem from '@mui/joy/MenuItem';
import Stack from '@mui/joy/Stack';

import ListItemDecorator from '@mui/joy/ListItemDecorator';

import Typography from '@mui/joy/Typography';
import Tooltip from '@mui/joy/Tooltip';


import IdentityAvatar from './IdentityAvatar';
import Link from './Link';
import useUserIdentity from 'hooks/useUserIdentity';
import useRoles from 'hooks/useRoles';

import { Identity, IdentityProps } from 'stores/identity_store';
import { getIcon } from 'utils/misc';
import { RecentsContext } from 'contexts/recents_context';

import { useColorScheme as useJoyColorScheme } from '@mui/joy/styles';
import { useColorScheme as useMaterialColorScheme } from '@mui/material/styles';


import Dropdown from "@mui/joy/Dropdown";
import Menu from "@mui/joy/Menu";
import MenuButton from "@mui/joy/MenuButton";
import Divider from "@mui/joy/Divider";
import { Success } from 'components/FancyToast';


// import useFun from 'hooks/useFun';

function UserIdentityPresenceIndicator({ identity } : { identity: IdentityProps }) {
    return <IdentityAvatar interactive={false} size="name" identityKey={identity.key} />
}


export function PresenceCompatibilityMenuItem() {
    const presence = navigator.userActivation;
    const serviceWorker = navigator.serviceWorker;
    const pushManager = ('PushManager' in window);
    const geo = ('geolocation' in navigator);

    const compatible = presence && serviceWorker && pushManager && geo;

    if (compatible) {
        const Icon = getIcon("SyncAlt");
        return (
            <Tooltip arrow placement="left" title="Your browser appears to be fully supported. Great!">
                <MenuItem variant="soft" color="success">

                    <ListItemDecorator sx={{ color: 'inherit' }}>
                        <Icon sx={{ mr: 1 }} />
                    </ListItemDecorator>

                    <Typography level="body-xs">
                        Your Setup Looks Good
                    </Typography>

                </MenuItem>
            </Tooltip>
        );
    }
    else {
        const Icon = getIcon("Dangerous");
        return (
            <MenuItem variant="soft" color="warning">
                <ListItemDecorator sx={{ color: 'inherit' }}>
                    <Icon sx={{ mr: 1 }} />
                </ListItemDecorator>
                <Tooltip arrow placement="top" title="There are compatibility issues with your browser">
                    <Stack spacing={1}>
                        {!presence && <Chip color="warning">Presence</Chip>}
                        {!serviceWorker && <Chip color="warning">Background Services</Chip>}
                        {!pushManager && <Chip color="warning">Push Notifications</Chip>}
                        {!geo && <Chip color="warning">Geo Location</Chip>}
                    </Stack>
                </Tooltip>
            </MenuItem>
        );
    }
}


export function ColorSchemeSwitcherRadio() {
    const { mode, setMode: setMaterialMode } = useMaterialColorScheme();
    const { setMode: setJoyMode } = useJoyColorScheme();
    const DarkMode = getIcon('DarkMode');
    const LightMode = getIcon('LightMode');
    const SystemMode = getIcon('SettingsBrightness');

    function setModeSuccess(nv: string) {
        if (nv === 'light') {
            setMaterialMode('light');
            setJoyMode('light');
        }
        else if (nv === 'dark') {
            setMaterialMode('dark');
            setJoyMode('dark');
        }
        else if (nv === 'system') {
            setMaterialMode('system');
            setJoyMode('system');
        }
        else {
            throw new Error("Invalid mode: " + nv);
        }
        Success("Set appearance to " + nv);
    }


    return (
        <ToggleButtonGroup
            value={mode}
            onChange={(e, nv) => {e.preventDefault();
                console.log("Setting to nv: %s", nv);
                setModeSuccess(nv || 'system')}}
            aria-label="Appearance"
            sx={{ mr: 1 }}
        >

            <Tooltip arrow placement="top" title="Match System Appearance">
                <Button
                    startDecorator={<SystemMode /> }
                    value="system">
                    System
                </Button>
            </Tooltip>

            <Tooltip arrow placement="top" title="Light Mode">
                <Button
                    startDecorator={<LightMode /> }
                    value="light">
                    Light
                </Button>
            </Tooltip>
            <Tooltip arrow placement="top" title="Dark Mode">
                <Button
                    startDecorator={<DarkMode />}
                    value="dark">
                    Dark
                </Button>
            </Tooltip>
        </ToggleButtonGroup>

    );
}

// function ColorSchemeSwitcher() {
//     const {mode, setMode } = useColorScheme();
//     const DarkMode = getIcon('DarkMode');
//     const LightMode = getIcon('LightMode');
//     const SystemMode = getIcon('SettingsBrightness');


//     //    const RD =
//                          // onClick={(e) => {e.preventDefault();
//                          //     setMode(mode == 'dark' ? 'light' : 'dark')}}
//                          // checked={mode == 'dark'}  />

//     return (
//         <>

//             <Tooltip arrow placement="left" title="Set your color theme">
//                 <MenuItem>
//                     <ListItemDecorator >
//                         { mode == "light" && <LightMode /> }
//                         { mode == "dark" && <DarkMode sx={{ color: "gold" }} /> }
//                         { mode == "system" && <SystemMode /> }
//                     </ListItemDecorator>
//                     <ListItemContent>
//                         Appearance
//                     </ListItemContent>
//                 </MenuItem>
//             </Tooltip>

//             <Tooltip arrow placement="left" title="Choose a color theme">
//                 <MenuItem>

//                     <ListItemDecorator>
//                     </ListItemDecorator>

//                     <ListItemContent>
//                         <ColorSchemeSwitcherRadio />
//                     </ListItemContent>
//                 </MenuItem>
//             </Tooltip>
//         </>
//     );
// }


// function SunriseSwitch() {
//     const { sunrise, setSunrise } = useFun();
//     const SunriseIcon = getIcon('Brightness7Outlined');
//     const Switchie = <Switch
//                          onClick={(e) => {e.preventDefault(); setSunrise && setSunrise(!sunrise)}}
//                          checked={sunrise}  />


//     return (
//         <Tooltip arrow placement="left" title="A little splash of color">
//             <MenuItem
//             >
//                 <ListItemDecorator >
//                     <SunriseIcon color={(sunrise ? "danger" : '')} />
//                 </ListItemDecorator>

//                 <ListItemContent>

//                     <Stack direction="row">
//                         <Typography level="body-sm">
//                             Sunrise Mode
//                         </Typography>
//                         <Box sx={{ flexGrow: 1 }} />
//                         {Switchie}
//                     </Stack>
//                 </ListItemContent>

//             </MenuItem>
//         </Tooltip>
//     );
// }


const UserPresenceIndicator = observer(() => {

    // const navigate  = useNavigate();
    const { identities, currentIdentity, setCurrentIdentity } = useUserIdentity();
    const { hasRole } = useRoles();
    const { clearRecents } = useContext(RecentsContext);
    const Logout = getIcon('Logout');

    // const BadgeClient = getIcon('AccountBox')
    const ContactPage = getIcon('ContactPageOutlined')
    const SettingsIcon = getIcon('SettingsOutlined')
    const SupportIcon = getIcon('ContactSupportOutlined');
    const SupportAgentIcon = getIcon('SupportAgent');
    const ManagerIcon = getIcon('AdminPanelSettingsOutlined');
    const otherIdentities = identities.filter((id) => id.key != currentIdentity?.key);

    if(!currentIdentity) {
        return null;
    }

    function updateIdentity(id: Identity) {
        clearRecents();
        setCurrentIdentity(id);
        Success("Great!")
        setTimeout(() => {
            window.location.reload();
        }, 100);
        // navigate(`/identity/${id.key}`);
    }

    if(!currentIdentity?.key) {
        return null;
    }

    return (
        <Dropdown>
            <MenuButton
                sx={
                    (theme) => ({
                        borderRadius: 0,
                        '&:hover': {
                            background: `rgba(${theme.vars.palette.primary.mainChannel} / 0.1)`
                            //          boxShadow: 'inset 0px 0px 4px rgba(0, 0, 0, 0.3)',
                        },
                    })
                }
                variant="plain">
                <IdentityAvatar size="avatar" interactive={false} identityKey={currentIdentity.key} />
            </MenuButton>

            <Menu>


                <Link to="/account">
                    <Tooltip arrow
                        placement="left"
                        title="View your account options">
                    <MenuItem>
                        <ListItemDecorator>
                            <ContactPage color="primary" />
                        </ListItemDecorator>
                        Account
                    </MenuItem>
                    </Tooltip>
                </Link>

                <Link to="/settings">
                    <Tooltip arrow
                        placement="left"
                        title="Update your settings">
                    <MenuItem>
                        <ListItemDecorator>
                            <SettingsIcon color="neutral" />
                        </ListItemDecorator>
                        Settings
                    </MenuItem>
                    </Tooltip>
                </Link>

                <Link to="/support">
                    <Tooltip arrow
                        placement="left"
                        title="Contact Support">
                    <MenuItem>
                        <ListItemDecorator>
                            <SupportIcon color="success" />
                        </ListItemDecorator>
                        Support
                    </MenuItem>
                    </Tooltip>
                </Link>


                {currentIdentity.role == 'assistant' &&
                    <>
                        {(hasRole('support') || hasRole('manager')) &&
                            <Divider />}

                        {hasRole('support') &&
                            <Link to="/support/dashboard">
                                <Tooltip arrow
                                    placement="left"
                                    title="Support Team Support">
                                    <MenuItem>
                                        <ListItemDecorator>
                                            <SupportAgentIcon color="warning" />
                                        </ListItemDecorator>
                                        Support Team
                                    </MenuItem>
                                </Tooltip>
                            </Link>
                        }

                        {hasRole('manager') &&
                            <Link to="/manager">
                                <Tooltip arrow
                                    placement="left"
                                    title="Manager Team Dashboard">
                                    <MenuItem>
                                        <ListItemDecorator>
                                            <ManagerIcon color="danger" />
                                        </ListItemDecorator>
                                        Manager
                                    </MenuItem>
                                </Tooltip>
                            </Link>
                        }
                    </>
                }
                { otherIdentities.length > 0 && <Divider /> }

                { otherIdentities.map((id) =>
                    <Tooltip arrow placement="left" title="Switch to this identity">
                    <MenuItem
                        key={id.key}
                        onClick={() => updateIdentity(id) }>
                        <ListItemDecorator>
                            <IdentityAvatar
                                width={22}
                                height={22}
                                size="avatar"
                                identityKey={id.uuid} />
                        </ListItemDecorator>
                        <UserIdentityPresenceIndicator key={id.key} identity={id} />
                    </MenuItem>
                    </Tooltip>
                ) }


                <Divider />

                <PresenceCompatibilityMenuItem />

                <Tooltip
                    arrow
                    placement="left"
                    title="You can always log back in">
                    <Link to="/logout">
                        <MenuItem>
                            <ListItemDecorator>
                                <Logout />
                            </ListItemDecorator>
                            Logout
                        </MenuItem>
                    </Link>
                </Tooltip>
            </Menu>
        </Dropdown>
    );
});
export default UserPresenceIndicator;
